export default "__VITE_ASSET__8f9cbdba__"